import React from 'react'
import {Box, SxProps, Theme} from '@mui/material'
import {NEUTRAL_SCALE} from 'src/theme-new/tokens'

interface LegalContentProps {
  html: string
  sx?: SxProps<Theme>
}

export default function LegalContent({html, sx}: LegalContentProps): JSX.Element {
  return (
    <Box
      sx={{
        color: NEUTRAL_SCALE[900],
        fontSize: 14,
        lineHeight: 1.6,
        wordBreak: 'break-word',
        '& *': {
          fontFamily: 'inherit !important',
          color: 'inherit',
          backgroundColor: 'transparent !important',
          fontSize: 'inherit !important',
          lineHeight: 'inherit !important',
          maxWidth: '100%',
        },
        '& p': {margin: '0 0 12px'},
        '& h1, & h2, & h3, & h4': {
          fontWeight: 700,
          margin: '16px 0 8px',
        },
        '& ul, & ol': {paddingLeft: '20px', margin: '8px 0'},
        '& li': {marginBottom: '4px'},
        '& a': {color: 'primary.main', textDecoration: 'underline'},
        '& table': {borderCollapse: 'collapse', width: '100%', margin: '8px 0'},
        '& th, & td': {
          border: `1px solid ${NEUTRAL_SCALE[200]}`,
          padding: '6px 8px',
          textAlign: 'left',
        },
        '& img': {maxWidth: '100%', height: 'auto'},
        ...sx,
      }}
      dangerouslySetInnerHTML={{__html: html ?? ''}}
    />
  )
}
